// import React, { useEffect, useMemo, useState } from "react";
// import {
//     Row,
//     Col,
//     Card,
//     CardBody,
//     Input,
//     Label,
//     Button,
//     Spinner,
// } from "reactstrap";
// import { useLocation, useNavigate } from "react-router-dom";
// import axiosConfig from "../../AxiosConfig";
// import swal from "sweetalert";

// const monthOrder = [
//     "April",
//     "May",
//     "June",
//     "July",
//     "August",
//     "September",
//     "October",
//     "November",
//     "December",
//     "January",
//     "February",
//     "March",
// ];

// const getCurrentFinancialYear = () => {
//     const today = new Date();
//     const year = today.getFullYear();
//     const month = today.getMonth() + 1;

//     if (month >= 4) {
//         return `${year}-${year + 1}`;
//     }

//     return `${year - 1}-${year}`;
// };

// const getFinancialYears = () => {
//     const currentYear = new Date().getFullYear();

//     return Array.from({ length: 6 }, (_, index) => {
//         const startYear = currentYear - index;
//         return `${startYear}-${startYear + 1}`;
//     });
// };

// const CreateAchievement = () => {
//     const navigate = useNavigate();
//     const location = useLocation();

//     const userData = JSON.parse(
//         localStorage.getItem("userData") || "{}"
//     );

//     const database = userData?.database;
//     const userId = userData?._id;

//     const editData = location?.state?.achievement || null;
//     const isEdit = Boolean(editData);

//     const [loading, setLoading] = useState(false);
//     const [saving, setSaving] = useState(false);
//     const [tableData, setTableData] = useState([]);
//     const [selectedStep, setSelectedStep] = useState("");
//     const [stepLoading, setStepLoading] = useState(false);
//     const [targetData, setTargetData] = useState([]);

//     const [formData, setFormData] = useState({
//         financialYear:
//             editData?.financialYear || getCurrentFinancialYear(),

//         month: editData?.month || "",

//         productId: editData?.productId || "",

//         productName: editData?.productName || "",

//         targetQty: Number(editData?.targetQty || 0),

//         achievementQty:
//             editData?.achievementQty !== undefined
//                 ? Number(editData.achievementQty)
//                 : "",
//     });

//     // =========================================================
//     // GET TARGET DATA
//     // =========================================================

//     const getTargetData = async () => {
//         try {
//             setLoading(true);

//             const res = await axiosConfig.get(
//                 `/production-steps/view-workerTarget/${database}/${formData.financialYear}`
//             );

//             if (res?.data?.status) {
//                 const targets = Array.isArray(res?.data?.targets)
//                     ? res.data.targets
//                     : [];

//                 setTargetData(targets);
//             } else {
//                 setTargetData([]);
//             }
//         } catch (error) {
//             console.log("Target API Error:", error);

//             setTargetData([]);

//             swal(
//                 "Error",
//                 "Unable to load target data",
//                 "error"
//             );
//         } finally {
//             setLoading(false);
//         }
//     };

//     useEffect(() => {
//         if (database && formData.financialYear) {
//             getTargetData();
//         }
//     }, [database, formData.financialYear]);

//     // =========================================================
//     // GET ACTIVE TARGET
//     // =========================================================

//     const activeTarget = useMemo(() => {
//         if (!Array.isArray(targetData)) {
//             return null;
//         }

//         /*
//           Target response:
    
//           {
//             financialYear: "2026-2027",
//             month: [
//               { April: 100 },
//               { May: 100 },
//               ...
//             ],
//             products: [...]
//           }
//         */

//         const target = targetData.find((item) => {
//             return (
//                 item?.financialYear ===
//                 formData.financialYear &&
//                 item?.status === "Active" &&
//                 Array.isArray(item?.products) &&
//                 item.products.length > 0
//             );
//         });

//         return target || null;
//     }, [
//         targetData,
//         formData.financialYear,
//     ]);
//     const getSteps = async () => {
//         try {
//             setStepLoading(true);

//             const res = await axiosConfig.get(
//                 `/production-step/view-steps/${userData?._id}`
//             );
// debugger
//             setTableData(res?.data?.steps || []);
//         } catch (error) {
//             console.log("Step API Error:", error);

//             setTableData([]);
//         } finally {
//             setStepLoading(false);
//         }
//     };
//     useEffect(() => {
//         if (userData?._id) {
//             getSteps();
//         }
//     }, [userData?._id]);
//     const steps = useMemo(() => {
//         if (!Array.isArray(tableData)) {
//             return [];
//         }

//         return tableData?.[0]?.steps || [];
//     }, [tableData]);
//     // =========================================================
//     // PRODUCTS
//     // =========================================================

//     const products = useMemo(() => {
//         if (!activeTarget) {
//             return [];
//         }

//         return Array.isArray(activeTarget.products)
//             ? activeTarget.products
//             : [];
//     }, [activeTarget]);

//     // =========================================================
//     // SELECTED PRODUCT
//     // =========================================================

//     const selectedProduct = useMemo(() => {
//         if (!formData.productId) {
//             return null;
//         }

//         return products.find(
//             (product) =>
//                 product?.productId ===
//                 formData.productId
//         );
//     }, [
//         products,
//         formData.productId,
//     ]);

//     // =========================================================
//     // BALANCE
//     // =========================================================

//     const balanceQty =
//         Number(formData.targetQty || 0) -
//         Number(formData.achievementQty || 0);

//     // =========================================================
//     // FINANCIAL YEAR CHANGE
//     // =========================================================

//     const handleFinancialYearChange = (e) => {
//         const value = e.target.value;

//         setFormData((prev) => ({
//             ...prev,

//             financialYear: value,

//             productId: "",
//             productName: "",
//             targetQty: 0,
//             achievementQty: "",
//         }));
//     };

//     // =========================================================
//     // MONTH CHANGE
//     // =========================================================

//     const handleMonthChange = (e) => {
//         const value = e.target.value;

//         setFormData((prev) => ({
//             ...prev,

//             month: value,
//         }));
//     };

//     // =========================================================
//     // PRODUCT CHANGE
//     // =========================================================

//     const handleProductChange = (e) => {
//         const productId = e.target.value;

//         const product = products.find(
//             (item) =>
//                 item?.productId === productId
//         );

//         if (!product) {
//             setFormData((prev) => ({
//                 ...prev,

//                 productId: "",
//                 productName: "",
//                 targetQty: 0,
//                 achievementQty: "",
//             }));

//             return;
//         }

//         setFormData((prev) => ({
//             ...prev,

//             productId:
//                 product?.productId || "",

//             productName:
//                 product?.productName || "",

//             targetQty:
//                 Number(product?.targetQty || 0),

//             achievementQty: "",
//         }));
//     };

//     // =========================================================
//     // ACHIEVEMENT CHANGE
//     // =========================================================

//     const handleAchievementChange = (e) => {
//         const value = e.target.value;

//         setFormData((prev) => ({
//             ...prev,

//             achievementQty:
//                 value === ""
//                     ? ""
//                     : Number(value),
//         }));
//     };

//     // =========================================================
//     // SAVE ACHIEVEMENT
//     // =========================================================

//     const handleSave = async () => {
//         if (!formData.financialYear) {
//             swal(
//                 "Required",
//                 "Please select financial year",
//                 "warning"
//             );
//             return;
//         }

//         if (!formData.month) {
//             swal(
//                 "Required",
//                 "Please select month",
//                 "warning"
//             );
//             return;
//         }

//         if (!formData.productId) {
//             swal(
//                 "Required",
//                 "Please select product",
//                 "warning"
//             );
//             return;
//         }

//         if (
//             formData.achievementQty === "" ||
//             formData.achievementQty === null ||
//             formData.achievementQty === undefined
//         ) {
//             swal(
//                 "Required",
//                 "Please enter achievement quantity",
//                 "warning"
//             );
//             return;
//         }

//         const achievementQty = Number(
//             formData.achievementQty || 0
//         );

//         const targetQty = Number(
//             formData.targetQty || 0
//         );

//         if (achievementQty < 0) {
//             swal(
//                 "Invalid Quantity",
//                 "Achievement quantity cannot be negative",
//                 "warning"
//             );
//             return;
//         }

//         /*
//           ========================================================
//           DEMO PAYLOAD
    
//           Baad me API ke according yahin payload change karna hai.
//           ========================================================
//         */

//         const payload = {
//             financialYear: formData.financialYear,
//             month: formData.month,

//             stepName: selectedStep,

//             productId: formData.productId,
//             productName: formData.productName,

//             targetQty: Number(formData.targetQty || 0),

//             achievementQty: Number(
//                 formData.achievementQty || 0
//             ),

//             balanceQty:
//                 Number(formData.targetQty || 0) -
//                 Number(formData.achievementQty || 0),

//             database: database,
//             created_by: userId,
//         };

//         console.log(
//             "Achievement Payload:",
//             payload
//         );
//         try {
//             setSaving(true);

//             /*
//               ======================================================
//               DEMO API
      
//               Baad me sirf is endpoint ko change kar dena.
      
//               POST:
//               /production-steps/create-workerAchievement/${database}
      
//               ======================================================
//             */

//             const url = isEdit
//                 ? `/production-steps/update-workerAchievement/${editData?._id}`
//                 : `/production-steps/save-achievemeny`;

//             const response = isEdit
//                 ? await axiosConfig.put(
//                     url,
//                     payload
//                 )
//                 : await axiosConfig.post(
//                     url,
//                     payload
//                 );

//             console.log(
//                 "Achievement Save Response:",
//                 response
//             );

//             if (
//                 response?.data?.status ||
//                 response?.status === 200 ||
//                 response?.status === 201
//             ) {
//                 swal(
//                     "Success",
//                     isEdit
//                         ? "Achievement updated successfully"
//                         : "Achievement saved successfully",
//                     "success"
//                 );

//                 navigate(
//                     "/sales-and-purchases?view=targets"
//                 );
//             } else {
//                 swal(
//                     "Error",
//                     response?.data?.message ||
//                     "Unable to save achievement",
//                     "error"
//                 );
//             }
//         } catch (error) {
//             console.log(
//                 "Achievement Save Error:",
//                 error
//             );

//             swal(
//                 "Error",
//                 error?.response?.data?.message ||
//                 "Achievement API failed",
//                 "error"
//             );
//         } finally {
//             setSaving(false);
//         }
//     };

//     // =========================================================
//     // CANCEL
//     // =========================================================

//     const handleCancel = () => {
//         navigate(
//             "/sales-and-purchases?view=targets"
//         );
//     };

//     // =========================================================
//     // UI
//     // =========================================================

//     return (
//         <div className="container-fluid">

//             {/* HEADER */}
//             <Row className="mb-3 align-items-center">
//                 <Col md="8">
//                     <h4
//                         style={{
//                             margin: 0,
//                             fontWeight: "600",
//                         }}
//                     >
//                         {isEdit
//                             ? "Edit Achievement"
//                             : "Create Achievement"}
//                     </h4>
//                 </Col>

//                 <Col
//                     md="4"
//                     className="text-end"
//                 >
//                     <Button
//                         color="secondary"
//                         outline
//                         onClick={handleCancel}
//                     >
//                         Back
//                     </Button>
//                 </Col>
//             </Row>

//             <Card>
//                 <CardBody>

//                     {/* TOP FILTERS */}
//                     <Row>

//                         {/* FINANCIAL YEAR */}
//                         <Col
//                             md="3"
//                             sm="12"
//                             className="mb-3"
//                         >
//                             <Label className="fw-semibold">
//                                 Financial Year
//                             </Label>

//                             <Input
//                                 type="select"
//                                 value={
//                                     formData.financialYear
//                                 }
//                                 onChange={
//                                     handleFinancialYearChange
//                                 }
//                             >
//                                 {getFinancialYears().map(
//                                     (year) => (
//                                         <option
//                                             key={year}
//                                             value={year}
//                                         >
//                                             {year}
//                                         </option>
//                                     )
//                                 )}
//                             </Input>
//                         </Col>

//                         {/* MONTH */}
//                         <Col
//                             md="3"
//                             sm="12"
//                             className="mb-3"
//                         >
//                             <Label className="fw-semibold">
//                                 Month
//                             </Label>

//                             <Input
//                                 type="select"
//                                 value={formData.month}
//                                 onChange={
//                                     handleMonthChange
//                                 }
//                             >
//                                 <option value="">
//                                     Select Month
//                                 </option>

//                                 {monthOrder.map(
//                                     (month) => (
//                                         <option
//                                             key={month}
//                                             value={month}
//                                         >
//                                             {month}
//                                         </option>
//                                     )
//                                 )}
//                             </Input>
//                         </Col>

//                         {/* PRODUCT */}
//                         <Col
//                             md="3"
//                             sm="12"
//                             className="mb-3"
//                         >
//                             <Label className="fw-semibold">
//                                 Product
//                             </Label>

//                             {loading ? (
//                                 <div
//                                     className="d-flex align-items-center"
//                                     style={{
//                                         height: "38px",
//                                     }}
//                                 >
//                                     <Spinner
//                                         size="sm"
//                                         className="me-2"
//                                     />

//                                     Loading products...
//                                 </div>
//                             ) : (
//                                 <Input
//                                     type="select"
//                                     value={
//                                         formData.productId
//                                     }
//                                     onChange={
//                                         handleProductChange
//                                     }
//                                     disabled={
//                                         !formData.month ||
//                                         products.length === 0
//                                     }
//                                 >
//                                     <option value="">
//                                         Select Product
//                                     </option>

//                                     {products.map(
//                                         (product) => (
//                                             <option
//                                                 key={
//                                                     product.productId
//                                                 }
//                                                 value={
//                                                     product.productId
//                                                 }
//                                             >
//                                                 {
//                                                     product.productName
//                                                 }
//                                             </option>
//                                         )
//                                     )}
//                                 </Input>
//                             )}

//                             {!loading &&
//                                 formData.month &&
//                                 products.length === 0 && (
//                                     <small className="text-danger">
//                                         No target product found.
//                                     </small>
//                                 )}
//                         </Col>
//                         <Col
//                             md="3"
//                             sm="12"
//                             className="mb-3"
//                         >
//                             <Label className="fw-semibold">
//                                 Step
//                             </Label>

//                             {stepLoading ? (
//                                 <div
//                                     className="d-flex align-items-center"
//                                     style={{
//                                         height: "38px",
//                                     }}
//                                 >
//                                     <Spinner
//                                         size="sm"
//                                         className="me-2"
//                                     />
//                                     Loading steps...
//                                 </div>
//                             ) : (
//                                 <Input
//                                     type="select"
//                                     value={selectedStep}
//                                     onChange={(e) =>
//                                         setSelectedStep(e.target.value)
//                                     }
//                                 >
//                                     <option value="">
//                                         Select Step
//                                     </option>

//                                     {steps.map((step, index) => (
//                                         <option
//                                             key={
//                                                 step?.step_No || index
//                                             }
//                                             value={step?.step_Name}
//                                         >
//                                             {step?.step_Name}
//                                         </option>
//                                     ))}
//                                 </Input>
//                             )}
//                         </Col>
//                     </Row>

//                     <hr />

//                     {/* SELECTED PRODUCT INFO */}
//                     {formData.productId && (
//                         <>
//                             <Row className="mb-3">

//                                 <Col md="12">
//                                     <h5
//                                         style={{
//                                             fontWeight: "600",
//                                             marginBottom: "15px",
//                                         }}
//                                     >
//                                         Achievement Details
//                                     </h5>
//                                 </Col>

//                                 {/* PRODUCT NAME */}
//                                 <Col
//                                     md="4"
//                                     sm="12"
//                                     className="mb-3"
//                                 >
//                                     <Label className="fw-semibold">
//                                         Product
//                                     </Label>

//                                     <Input
//                                         type="text"
//                                         value={
//                                             formData.productName
//                                         }
//                                         readOnly
//                                     />
//                                 </Col>

//                                 {/* TARGET */}
//                                 <Col
//                                     md="4"
//                                     sm="12"
//                                     className="mb-3"
//                                 >
//                                     <Label className="fw-semibold">
//                                         Target Qty
//                                     </Label>

//                                     <Input
//                                         type="number"
//                                         value={
//                                             Number(
//                                                 formData.targetQty ||
//                                                 0
//                                             ).toFixed(2)
//                                         }
//                                         readOnly
//                                         style={{
//                                             backgroundColor:
//                                                 "#f8f9fa",
//                                             fontWeight: "600",
//                                         }}
//                                     />
//                                 </Col>

//                                 {/* ACHIEVEMENT */}
//                                 <Col
//                                     md="4"
//                                     sm="12"
//                                     className="mb-3"
//                                 >
//                                     <Label className="fw-semibold">
//                                         Achievement Qty
//                                     </Label>

//                                     <Input
//                                         type="number"
//                                         min="0"
//                                         step="0.01"
//                                         value={
//                                             formData.achievementQty
//                                         }
//                                         onChange={
//                                             handleAchievementChange
//                                         }
//                                         placeholder="Enter achieved quantity"
//                                     />
//                                 </Col>
//                             </Row>

//                             {/* BALANCE */}
//                             <Row>

//                                 <Col md="4">
//                                     <div
//                                         className="border rounded p-3"
//                                         style={{
//                                             backgroundColor:
//                                                 "#f8f9fa",
//                                         }}
//                                     >
//                                         <div
//                                             className="text-muted"
//                                             style={{
//                                                 fontSize: "13px",
//                                             }}
//                                         >
//                                             Target
//                                         </div>

//                                         <div
//                                             style={{
//                                                 fontSize: "22px",
//                                                 fontWeight: "600",
//                                             }}
//                                         >
//                                             {Number(
//                                                 formData.targetQty ||
//                                                 0
//                                             ).toFixed(2)}
//                                         </div>
//                                     </div>
//                                 </Col>

//                                 <Col md="4">
//                                     <div
//                                         className="border rounded p-3"
//                                         style={{
//                                             backgroundColor:
//                                                 "#f8f9fa",
//                                         }}
//                                     >
//                                         <div
//                                             className="text-muted"
//                                             style={{
//                                                 fontSize: "13px",
//                                             }}
//                                         >
//                                             Achievement
//                                         </div>

//                                         <div
//                                             style={{
//                                                 fontSize: "22px",
//                                                 fontWeight: "600",
//                                             }}
//                                         >
//                                             {Number(
//                                                 formData.achievementQty ||
//                                                 0
//                                             ).toFixed(2)}
//                                         </div>
//                                     </div>
//                                 </Col>

//                                 <Col md="4">
//                                     <div
//                                         className="border rounded p-3"
//                                         style={{
//                                             backgroundColor:
//                                                 balanceQty < 0
//                                                     ? "#fff5f5"
//                                                     : "#f8f9fa",
//                                         }}
//                                     >
//                                         <div
//                                             className="text-muted"
//                                             style={{
//                                                 fontSize: "13px",
//                                             }}
//                                         >
//                                             Balance
//                                         </div>

//                                         <div
//                                             style={{
//                                                 fontSize: "22px",
//                                                 fontWeight: "600",
//                                             }}
//                                         >
//                                             {Number(
//                                                 balanceQty
//                                             ).toFixed(2)}
//                                         </div>
//                                     </div>
//                                 </Col>

//                             </Row>

//                             {/* ACTION BUTTONS */}
//                             <div className="d-flex justify-content-end mt-4">

//                                 <Button
//                                     color="secondary"
//                                     outline
//                                     className="me-2"
//                                     onClick={handleCancel}
//                                     disabled={saving}
//                                 >
//                                     Cancel
//                                 </Button>

//                                 <Button
//                                     color="success"
//                                     onClick={handleSave}
//                                     disabled={saving}
//                                 >
//                                     {saving ? (
//                                         <>
//                                             <Spinner
//                                                 size="sm"
//                                                 className="me-2"
//                                             />
//                                             Saving...
//                                         </>
//                                     ) : isEdit ? (
//                                         "Update Achievement"
//                                     ) : (
//                                         "Save Achievement"
//                                     )}
//                                 </Button>

//                             </div>
//                         </>
//                     )}

//                     {/* NO PRODUCT SELECTED */}
//                     {!formData.productId &&
//                         !loading && (
//                             <div
//                                 className="text-center text-muted py-5"
//                             >
//                                 <div
//                                     style={{
//                                         fontSize: "15px",
//                                     }}
//                                 >
//                                     Please select a month and
//                                     product to enter achievement.
//                                 </div>
//                             </div>
//                         )}

//                 </CardBody>
//             </Card>
//         </div>
//     );
// };

// export default CreateAchievement;











import React, {
  useEffect,
  useMemo,
  useState,
  useRef
} from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  Input,
  Label,
  Spinner,
} from "reactstrap";
import { useNavigate } from "react-router-dom";
import axiosConfig from "../../AxiosConfig";

// ======================================================
// MONTH ORDER
// ======================================================

const monthOrder = [
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
  "January",
  "February",
  "March",
];

// ======================================================
// CURRENT FINANCIAL YEAR
// ======================================================

const getCurrentFinancialYear = () => {
  const today = new Date();

  const year = today.getFullYear();
  const month = today.getMonth() + 1;

  if (month >= 4) {
    return `${year}-${year + 1}`;
  }

  return `${year - 1}-${year}`;
};

// ======================================================
// FINANCIAL YEAR LIST
// ======================================================

const getFinancialYears = () => {
  const currentYear =
    new Date().getFullYear();

  return Array.from(
    { length: 6 },
    (_, index) => {
      const startYear =
        currentYear - index;

      return `${startYear}-${startYear + 1}`;
    }
  );
};

// ======================================================
// COMPONENT
// ======================================================
const CreateAchievement = () => {
  const navigate = useNavigate();
const tableRef = useRef(null);
  // ======================================================
  // USER
  // ======================================================

  const getUserData = () => {
    try {
      return JSON.parse(
        localStorage.getItem("userData") || "{}"
      );
    } catch (error) {
      return {};
    }
  };

  const user = getUserData();

  const database = user?.database;

  // ======================================================
  // LOADING
  // ======================================================

  const [targetLoading, setTargetLoading] =
    useState(false);

  const [productionLoading, setProductionLoading] =
    useState(false);

  // ======================================================
  // DATA
  // ======================================================

  const [targetData, setTargetData] =
    useState([]);

  const [productionData, setProductionData] =
    useState([]);

  // ======================================================
  // EXPANDED PRODUCTS
  // ======================================================

  const [expandedProducts, setExpandedProducts] =
    useState({});

  // ======================================================
  // FORM
  // ======================================================

  const [formData, setFormData] = useState({
    financialYear: getCurrentFinancialYear(),
    month: "",
  });

  // ======================================================
  // GET TARGET DATA
  // ======================================================

  const loadTargetData = async () => {
    try {
      setTargetLoading(true);

      if (!database) {
        setTargetData([]);
        return;
      }

      const response = await axiosConfig.get(
        `/production-steps/view-workerTarget/${database}/${formData.financialYear}`
      );

      console.log(
        "Target API Response:",
        response?.data
      );

      const targets = Array.isArray(
        response?.data?.targets
      )
        ? response.data.targets
        : [];

      console.log(
        "Targets:",
        targets
      );

      setTargetData(targets);
    } catch (error) {
      console.error(
        "Target API Error:",
        error
      );

      setTargetData([]);
    } finally {
      setTargetLoading(false);
    }
  };

  // ======================================================
  // GET PRODUCTION DATA
  // ======================================================

  const loadProductionData = async () => {
    try {
      setProductionLoading(true);

      const userData = JSON.parse(
        localStorage.getItem("userData") || "{}"
      );

      if (!userData?.database) {
        setProductionData([]);
        return;
      }

      const response =
        await axiosConfig.get(
          `/production-steps/view-ProductionList/${userData.database}/${formData.financialYear}`
        );

      console.log(
        "Production API Response:",
        response?.data
      );

      const allProduction =
        Array.isArray(
          response?.data?.product
        )
          ? response.data.product
          : [];

      console.log(
        "All Production:",
        allProduction
      );

      setProductionData(
        allProduction
      );
    } catch (error) {
      console.error(
        "Production API Error:",
        error
      );

      setProductionData([]);
    } finally {
      setProductionLoading(false);
    }
  };

  // ======================================================
  // LOAD BOTH APIs WHEN FINANCIAL YEAR CHANGES
  // ======================================================

  useEffect(() => {
    if (
      database &&
      formData.financialYear
    ) {
      loadTargetData();
      loadProductionData();
    }
  }, [
    database,
    formData.financialYear,
  ]);

  // ======================================================
  // TARGET PRODUCTS
  //
  // Selected month ke target products
  // ======================================================
useEffect(() => {
  const handleOutsideClick = (event) => {
    if (
      tableRef.current &&
      !tableRef.current.contains(event.target)
    ) {
      setExpandedProducts({});
    }
  };

  document.addEventListener("mousedown", handleOutsideClick);

  return () => {
    document.removeEventListener("mousedown", handleOutsideClick);
  };
}, []);
const products = useMemo(() => {
  if (!Array.isArray(targetData) || !formData.month) {
    return [];
  }

  const productMap = new Map();

  const selectedMonth = String(formData.month)
    .trim()
    .toLowerCase();

  targetData.forEach((target) => {
    if (!Array.isArray(target?.month)) {
      return;
    }

    // month array:
    // [
    //   { April: 120000 },
    //   { May: 120000 },
    //   ...
    // ]

    const selectedMonthObject = target.month.find((monthObj) => {
      if (!monthObj || typeof monthObj !== "object") {
        return false;
      }

      return Object.keys(monthObj).some(
        (monthName) =>
          String(monthName).trim().toLowerCase() === selectedMonth
      );
    });

    // Selected month target me nahi mila
    if (!selectedMonthObject) {
      return;
    }

    if (!Array.isArray(target?.products)) {
      return;
    }

    target.products.forEach((product) => {
      const productId = String(
        product?.productId ||
          product?.id ||
          product?._id ||
          ""
      ).trim();

      if (!productId) {
        return;
      }

      const productName =
        product?.productName ||
        product?.product_name ||
        product?.name ||
        product?.Product_Title ||
        "-";

      // Product ka targetQty
      // Agar product me targetQty available hai to wahi use hoga
      const productTargetQty = Number(
        product?.targetQty || 0
      );

      // Month object se selected month ki qty
      const monthTargetQty = Number(
        selectedMonthObject?.[Object.keys(selectedMonthObject).find(
          (key) =>
            String(key).trim().toLowerCase() === selectedMonth
        )] || 0
      );

      // Monthly target ke liye month ki qty use karo
      const targetQty =
        monthTargetQty > 0
          ? monthTargetQty
          : productTargetQty;

      if (!productMap.has(productId)) {
        productMap.set(productId, {
          ...product,
          productId,
          productName,
          targetQty,
        });
      } else {
        const existing = productMap.get(productId);

        existing.targetQty =
          Number(existing.targetQty || 0) + targetQty;
      }
    });
  });

  console.log("Selected Month:", formData.month);
  console.log(
    "Filtered Target Products:",
    Array.from(productMap.values())
  );

  return Array.from(productMap.values());
}, [targetData, formData.month]);

  // ======================================================
  // TARGET PRODUCT NAME
  // ======================================================

  const getTargetProductName = (
    product
  ) => {
    return (
      product?.productName ||
      product?.product_name ||
      product?.name ||
      product?.Product_Title ||
      product?.id ||
      ""
    );
  };

  // ======================================================
  // GET PRODUCTION FINAL PRODUCTS
  // ======================================================

  const getProductionFinalProducts = (
    item
  ) => {
    return Array.isArray(
      item
        ?.product_details?.[0]
        ?.finalProductDetails
    )
      ? item.product_details[0]
          .finalProductDetails
      : [];
  };

  // ======================================================
  // GET PRODUCTION MONTH
  // ======================================================

  const getProductionMonth = (
    item
  ) => {
    if (!item?.date) {
      return "";
    }

    const date =
      new Date(item.date);

    if (
      Number.isNaN(
        date.getTime()
      )
    ) {
      return "";
    }

    return date.toLocaleString(
      "en-US",
      {
        month: "long",
      }
    );
  };

  // ======================================================
  // GET PRODUCTION QTY
  // ======================================================

  const getProductionQty = (
    finalProduct
  ) => {
    const units =
      finalProduct
        ?.fProduct_name_Units;

    if (!Array.isArray(units)) {
      return 0;
    }

    const sheetUnit =
      units.find(
        (item) =>
          String(
            item?.unit || ""
          )
            .trim()
            .toLowerCase() ===
          "sheet"
      );

    return Number(
      sheetUnit?.qty || 0
    );
  };

  // ======================================================
  // GET PRODUCTION PRODUCT ID
  // ======================================================

  const getProductionProductId = (
    finalProduct
  ) => {
    const fProduct =
      finalProduct?.fProduct_name;

    return String(
      fProduct?.id ||
        fProduct?._id ||
        ""
    ).trim();
  };

  // ======================================================
  // GET PRODUCTION PRODUCT NAME
  // ======================================================

  const getProductionProductName = (
    finalProduct
  ) => {
    const fProduct =
      finalProduct?.fProduct_name;

    return (
      fProduct?.Product_Title ||
      fProduct?.id ||
      fProduct?._id ||
      "-"
    );
  };

  // ======================================================
  // CHECK COMPLETED PRODUCTION
  // ======================================================

  const isCompletedProduction = (
    production
  ) => {
    const status = String(
      production?.product_details?.find(
        (item) => item?.status
      )?.status || ""
    )
      .trim()
      .toLowerCase();

    return status === "completed";
  };

  // ======================================================
  // PRODUCTION SUMMARY
  //
  // Product wise achievement
  // selected month + completed only
  // ======================================================

  const productionSummary = useMemo(() => {
  if (!Array.isArray(productionData)) {
    return [];
  }

  const productMap = new Map();

  productionData.forEach((production) => {
    // ============================================
    // ONLY COMPLETED PRODUCTION
    // ============================================

    const isCompleted = production?.product_details?.some(
      (detail) =>
        String(detail?.status || "")
          .trim()
          .toLowerCase() === "completed"
    );
    if (!isCompleted) {
      return;
    }

    // ============================================
    // MONTH FILTER
    // ============================================

   

    // ============================================
    // GET ALL FINAL PRODUCTS
    // ============================================

    const finalProducts = (
      production?.product_details || []
    ).flatMap((detail) =>
      Array.isArray(detail?.finalProductDetails)
        ? detail.finalProductDetails
        : []
    );

    // ============================================
    // FINAL PRODUCT WISE
    // ============================================

    finalProducts.forEach((finalProduct) => {
      const fProduct =
        finalProduct?.fProduct_name;

      const productId = String(
        fProduct?._id ||
          fProduct?.id ||
          ""
      ).trim();

      if (!productId) {
        return;
      }

      const productName =
        fProduct?.Product_Title ||
        fProduct?.id ||
        fProduct?._id ||
        "-";

      // ==========================================
      // ACHIEVEMENT = SHEET QTY
      // ==========================================

      const units =
        finalProduct?.fProduct_name_Units;

      const sheetUnit = Array.isArray(units)
        ? units.find(
            (unit) =>
              String(unit?.unit || "")
                .trim()
                .toLowerCase() === "sheet"
          )
        : null;

      const achievementQty = Number(
        sheetUnit?.qty || 0
      );

      // ==========================================
      // ADD / UPDATE PRODUCT
      // ==========================================

      if (!productMap.has(productId)) {
       productMap.set(productId, {
  productId,
  productName,
  stepName:
    production?.step_name ||
    production?.stepName ||
    "-",
  achievementQty: 0,
});
      }

      const existing =
        productMap.get(productId);

      existing.achievementQty +=
        achievementQty;
    });
  });

  const result = Array.from(
    productMap.values()
  );

  console.log(
    "FINAL PRODUCTION SUMMARY:",
    result
  );

  return result;
}, [
  productionData,
  formData.month,
]);

  // ======================================================
  // FIND PRODUCTION PRODUCTS FOR TARGET PRODUCT
  //
  // First ID match
  // Then name match
  // ======================================================

 const getChildProductionProducts = (targetProduct) => {
  if (!Array.isArray(productionSummary)) {
    return [];
  }

  // Target product aur production product ka ID/name
  // same hona zaroori nahi hai.
  //
  // Selected month + Completed production already
  // productionSummary me filter ho chuki hai.
  //
  // Isliye parent ke andar saare production products
  // child rows me show honge.

  return productionSummary;
};

  // ======================================================
  // TOGGLE EXPAND / COLLAPSE
  // ======================================================

  const toggleProduct = (
    productId
  ) => {
    setExpandedProducts(
      (prev) => ({
        ...prev,

        [productId]:
          !prev[productId],
      })
    );
  };

  // ======================================================
  // FINANCIAL YEAR CHANGE
  // ======================================================

  const handleFinancialYearChange =
    (e) => {
      const value =
        e.target.value;

      setFormData({
        financialYear:
          value,

        month: "",
      });

      setExpandedProducts({});
    };

  // ======================================================
  // MONTH CHANGE
  // ======================================================

  const handleMonthChange = (
    e
  ) => {
    const value =
      e.target.value;

    setFormData(
      (prev) => ({
        ...prev,

        month: value,
      })
    );

    setExpandedProducts({});
  };

  // ======================================================
  // TOTAL TARGET
  // ======================================================

  const totalTargetQty =
    useMemo(() => {
      return products.reduce(
        (total, product) =>
          total +
          Number(
            product?.targetQty ||
              0
          ),
        0
      );
    }, [products]);

  // ======================================================
  // TOTAL ACHIEVEMENT
  // ======================================================
const totalAchievementQty = useMemo(
  () =>
    productionSummary.reduce(
      (total, product) =>
        total + Number(product?.achievementQty || 0),
      0
    ),
  [productionSummary]
);

  // ======================================================
  // TOTAL BALANCE
  // ======================================================

  const totalBalanceQty =
    Number(
      totalTargetQty || 0
    ) -
    Number(
      totalAchievementQty || 0
    );

  // ======================================================
  // RENDER
  // ======================================================

  return (
    <div className="container-fluid">

      {/* ==================================================
          HEADER
      ================================================== */}

      <Row className="align-items-center mb-3">

        <Col md="8">

          <h4
            style={{
              margin: 0,
              fontWeight: "600",
            }}
          >
            Achievement
          </h4>

        </Col>

        <Col
          md="4"
          className="text-end"
        >

          <button
            type="button"
            className="btn btn-secondary"
            onClick={() =>
              navigate(
                "/sales-and-purchases?view=targets"
              )
            }
          >
            Back
          </button>

        </Col>

      </Row>

      {/* ==================================================
          FILTER CARD
      ================================================== */}

      <Card>

        <CardBody>

          <Row>

            {/* ==========================================
                FINANCIAL YEAR
            ========================================== */}

            <Col
              md="6"
              sm="12"
              className="mb-3"
            >

              <Label
                className="fw-semibold"
              >
                Financial Year
              </Label>

              <Input
                type="select"
                value={
                  formData.financialYear
                }
                onChange={
                  handleFinancialYearChange
                }
              >

                {getFinancialYears().map(
                  (year) => (
                    <option
                      key={year}
                      value={year}
                    >
                      {year}
                    </option>
                  )
                )}

              </Input>

            </Col>

            {/* ==========================================
                MONTH
            ========================================== */}

            <Col
              md="6"
              sm="12"
              className="mb-3"
            >

              <Label
                className="fw-semibold"
              >
                Month
              </Label>

              <Input
                type="select"
                value={
                  formData.month
                }
                onChange={
                  handleMonthChange
                }
              >

                <option value="">
                  Select Month
                </option>

                {monthOrder.map(
                  (month) => (
                    <option
                      key={month}
                      value={month}
                    >
                      {month}
                    </option>
                  )
                )}

              </Input>

            </Col>

          </Row>

        </CardBody>

      </Card>

      {/* ==================================================
          ACHIEVEMENT TABLE
      ================================================== */}

      <Card className="mt-4">

        <CardBody>

          {/* ==========================================
              TABLE HEADER
          ========================================== */}

          <div className="d-flex justify-content-between align-items-center mb-3">

            <div>

              <h5 className="mb-1">
                Achievement Details
              </h5>

              {formData.month && (
                <small className="text-muted">
                  {formData.month}
                  {" • "}
                  {formData.financialYear}
                </small>
              )}

            </div>

            {formData.month && (
              <div>

                <strong>
                  Total Achievement:{" "}
                  {Number(
                    totalAchievementQty
                  ).toFixed(2)}
                </strong>

              </div>
            )}

          </div>

          {/* ==========================================
              NO MONTH
          ========================================== */}

          {!formData.month ? (

            <div
              className="text-center text-muted"
              style={{
                padding:
                  "50px 10px",
              }}
            >
              Select month to view
              Achievement.
            </div>

          ) : targetLoading ? (

            <div
              className="text-center p-4"
            >

              <Spinner
                color="primary"
              />

              <div className="mt-2">
                Loading target...
              </div>

            </div>

          ) : productionLoading &&
            products.length === 0 ? (

            <div
              className="text-center p-4"
            >

              <Spinner
                color="primary"
              />

              <div className="mt-2">
                Loading production...
              </div>

            </div>

          ) : products.length ===
            0 ? (

            <div
              className="text-center text-muted"
              style={{
                padding:
                  "50px 10px",
              }}
            >
              No target product found
              for{" "}
              <strong>
                {formData.month}
              </strong>
              .
            </div>

          ) : (

      <div className="table-responsive" ref={tableRef}>
  <table className="table table-bordered table-hover mb-0">

    <thead>
      <tr>
        <th
          style={{
            textAlign: "center",
            verticalAlign: "middle",
          }}
        >
          Product
        </th>

        <th
          style={{
            textAlign: "center",
            verticalAlign: "middle",
          }}
        >
          Target Qty
        </th>

        <th
          style={{
            textAlign: "center",
            verticalAlign: "middle",
          }}
        >
          Achievement Qty
        </th>

        <th
          style={{
            textAlign: "center",
            verticalAlign: "middle",
          }}
        >
          Balance
        </th>
      </tr>
    </thead>

    <tbody>
      {products.map((targetProduct, index) => {
        const productId = String(
          targetProduct?.productId || ""
        ).trim();

        const targetQty = Number(
          targetProduct?.targetQty || 0
        );

        const childProducts =
          getChildProductionProducts(targetProduct);

        const achievementQty = childProducts.reduce(
          (total, item) =>
            total +
            Number(item?.achievementQty || 0),
          0
        );

        const balance =
          targetQty - achievementQty;

        const isExpanded =
          !!expandedProducts[productId];

        return (
          <React.Fragment
            key={productId || index}
          >

            {/* ==============================
                PARENT ROW
            ============================== */}
            <tr>

              {/* PRODUCT */}
              <td
                onClick={() =>
                  toggleProduct(productId)
                }
                style={{
                  verticalAlign: "middle",
                  cursor: "pointer",
                  userSelect: "none",
                  textAlign: "center",
                }}
                title={
                  isExpanded
                    ? "Click to collapse"
                    : "Click to expand"
                }
              >
                <strong
                  style={{
                    color: "#007bff",
                  }}
                >
                  {getTargetProductName(
                    targetProduct
                  )}
                </strong>
              </td>

              {/* TARGET */}
              <td
                style={{
                  textAlign: "center",
                  verticalAlign: "middle",
                }}
              >
                {targetQty.toFixed(2)}
              </td>

              {/* ACHIEVEMENT */}
              <td
                style={{
                  textAlign: "center",
                  verticalAlign: "middle",
                }}
              >
                {achievementQty.toFixed(2)}
              </td>

              {/* BALANCE */}
              <td
                style={{
                  textAlign: "center",
                  verticalAlign: "middle",
                  fontWeight: "600",
                }}
              >
                {balance.toFixed(2)}
              </td>

            </tr>

            {/* ==============================
                CHILD ROW
            ============================== */}
            {isExpanded && (
              <tr>
                {/* MAIN TABLE HAS 4 COLUMNS */}
                <td
                  colSpan="4"
                  style={{
                    padding: 0,
                    background: "#f8f9fa",
                  }}
                >
                  <div
                    style={{
                      padding:
                        "12px 20px 12px 70px",
                    }}
                  >

                    <table className="table table-bordered table-sm mb-0">

                      <thead>
                        <tr>

                          <th
                            style={{
                              textAlign: "center",
                            }}
                          >
                            Production Product
                          </th>
 <th
      style={{
        textAlign: "center",
      }}
    >
      Step Name
    </th>
                          <th
                            style={{
                              textAlign: "center",
                            }}
                          >
                            Achievement Qty
                          </th>

                        </tr>
                      </thead>

                      <tbody>

                        {childProducts.length === 0 ? (
                          <tr>
                            <td
                              colSpan="3"
                              className="text-center text-muted"
                            >
                              No completed production
                              found.
                            </td>
                          </tr>
                        ) : (
                          childProducts.map(
                            (
                              child,
                              childIndex
                            ) => (
                              <tr
                                key={
                                  child?.productId ||
                                  childIndex
                                }
                              >

                                {/* PRODUCTION PRODUCT */}
                                <td
                                  style={{
                                    textAlign:
                                      "center",
                                  }}
                                >
                                  {child?.productName ||
                                    "-"}
                                </td>
 <td
    style={{
      textAlign: "center",
      textTransform: "capitalize",
    }}
  >
    {child?.stepName || "-"}
  </td>
                                {/* ACHIEVEMENT */}
                                <td
                                  style={{
                                    textAlign:
                                      "center",
                                  }}
                                >
                                  {Number(
                                    child?.achievementQty ||
                                      0
                                  ).toFixed(2)}
                                </td>

                              </tr>
                            )
                          )
                        )}

                      </tbody>

                    </table>
                  </div>
                </td>
              </tr>
            )}

          </React.Fragment>
        );
      })}
    </tbody>

    {/* ==============================
        FOOTER TOTAL
    ============================== */}
    <tfoot>
      <tr>

        {/* PRODUCT COLUMN */}
        <th
          style={{
            textAlign: "center",
            verticalAlign: "middle",
          }}
        >
          Total
        </th>

        {/* TARGET TOTAL */}
        <th
          style={{
            textAlign: "center",
            verticalAlign: "middle",
          }}
        >
          {Number(
            totalTargetQty
          ).toFixed(2)}
        </th>

        {/* ACHIEVEMENT TOTAL */}
        <th
          style={{
            textAlign: "center",
            verticalAlign: "middle",
          }}
        >
          {Number(
            totalAchievementQty
          ).toFixed(2)}
        </th>

        {/* BALANCE TOTAL */}
        <th
          style={{
            textAlign: "center",
            verticalAlign: "middle",
          }}
        >
          {Number(
            totalBalanceQty
          ).toFixed(2)}
        </th>

      </tr>
    </tfoot>

  </table>
</div>

          )}

        </CardBody>

      </Card>

    </div>
  );
};
// const CreateAchievement = () => {
//   const navigate = useNavigate();

//   // ======================================================
//   // USER
//   // ======================================================

//   const getUserData = () => {
//     try {
//       return JSON.parse(
//         localStorage.getItem("userData") || "{}"
//       );
//     } catch (error) {
//       return {};
//     }
//   };

//   const user = getUserData();

//   const database = user?.database;

//   // ======================================================
//   // LOADING
//   // ======================================================

//   const [targetLoading, setTargetLoading] =
//     useState(false);

//   const [productionLoading, setProductionLoading] =
//     useState(false);

//   // ======================================================
//   // TARGET DATA
//   // ======================================================

//   const [targetData, setTargetData] =
//     useState([]);

//   // ======================================================
//   // PRODUCTION DATA
//   // ======================================================

//   const [productionData, setProductionData] =
//     useState([]);

//   // ======================================================
//   // FORM
//   // ======================================================

//   const [formData, setFormData] = useState({
//     financialYear: getCurrentFinancialYear(),
//     month: "",
//     productId: "",
//     productName: "",
//     targetQty: 0,
//   });

//   // ======================================================
//   // GET TARGET DATA
//   // ======================================================

//   const loadTargetData = async () => {
//     try {
//       setTargetLoading(true);

//       if (!database) {
//         setTargetData([]);
//         return;
//       }

//       const response = await axiosConfig.get(
//         `/production-steps/view-workerTarget/${database}/${formData.financialYear}`
//       );

//       console.log(
//         "Target API Response:",
//         response?.data
//       );

//       const targets = Array.isArray(
//         response?.data?.targets
//       )
//         ? response.data.targets
//         : [];

//       console.log(
//         "Targets:",
//         targets
//       );

//       setTargetData(targets);
//     } catch (error) {
//       console.error(
//         "Target API Error:",
//         error
//       );

//       setTargetData([]);
//     } finally {
//       setTargetLoading(false);
//     }
//   };

//   // ======================================================
//   // GET PRODUCTION DATA
//   // ======================================================

//   const loadProductionData = async () => {
//     try {
//       setProductionLoading(true);

//       const userData = JSON.parse(
//         localStorage.getItem("userData") || "{}"
//       );

//       const financeYear =
//         formData.financialYear;

//       if (!userData?.database) {
//         setProductionData([]);
//         return;
//       }

//       const response =
//         await axiosConfig.get(
//           `/production-steps/view-ProductionList/${userData.database}/${financeYear}`
//         );
// debugger
//       console.log(
//         "Production API Response:",
//         response?.data
//       );

//       const allProduction =
//         Array.isArray(
//           response?.data?.product
//         )
//           ? response.data.product
//           : [];

//       console.log(
//         "All Production:",
//         allProduction
//       );

//       setProductionData(
//         allProduction
//       );
//     } catch (error) {
//       console.error(
//         "Production API Error:",
//         error
//       );

//       setProductionData([]);
//     } finally {
//       setProductionLoading(false);
//     }
//   };

//   // ======================================================
//   // LOAD BOTH APIs WHEN FY CHANGES
//   // ======================================================

//   useEffect(() => {
//     if (
//       database &&
//       formData.financialYear
//     ) {
//       loadTargetData();
//       loadProductionData();
//     }
//   }, [
//     database,
//     formData.financialYear,
//   ]);

//   // ======================================================
//   // GET PRODUCTS FROM TARGET
//   // ======================================================

//   const products = useMemo(() => {
//     if (
//       !Array.isArray(targetData)
//     ) {
//       return [];
//     }

//     const productMap = new Map();

//     targetData.forEach((target) => {
//       if (
//         !Array.isArray(
//           target?.products
//         )
//       ) {
//         return;
//       }

//       target.products.forEach(
//         (product) => {
//           const productId =
//             product?.productId;

//           if (!productId) {
//             return;
//           }

//           if (
//             !productMap.has(
//               String(productId)
//             )
//           ) {
//             productMap.set(
//               String(productId),
//               {
//                 ...product,

//                 targetQty:
//                   Number(
//                     product?.targetQty ||
//                       0
//                   ),
//               }
//             );
//           }
//         }
//       );
//     });

//     return Array.from(
//       productMap.values()
//     );
//   }, [targetData]);

//   // ======================================================
//   // SELECTED PRODUCT
//   // ======================================================

//   const selectedProduct = useMemo(() => {
//     if (
//       !formData.productId
//     ) {
//       return null;
//     }

//     return products.find(
//       (product) =>
//         String(
//           product?.productId
//         ) ===
//         String(
//           formData.productId
//         )
//     );
//   }, [
//     products,
//     formData.productId,
//   ]);

//   // ======================================================
//   // GET TARGET QTY
//   // ======================================================

//   const targetQty = useMemo(() => {
//     if (!selectedProduct) {
//       return 0;
//     }

//     return Number(
//       selectedProduct?.targetQty ||
//         0
//     );
//   }, [
//     selectedProduct,
//   ]);

//   // ======================================================
//   // GET TARGET PRODUCT NAME
//   // ======================================================

//   const getTargetProductName = (
//     product
//   ) => {
//     return (
//       product?.productName ||
//       product?.product_name ||
//       product?.name ||
//       product?.Product_Title ||
//       product?.id ||
//       ""
//     );
//   };

//   // ======================================================
//   // GET ALL FINAL PRODUCTS
//   // FROM PRODUCTION
//   // ======================================================

//   const getProductionFinalProducts = (
//     item
//   ) => {
//     return Array.isArray(
//       item
//         ?.product_details?.[0]
//         ?.finalProductDetails
//     )
//       ? item.product_details[0]
//           .finalProductDetails
//       : [];
//   };

//   // ======================================================
//   // GET PRODUCTION MONTH
//   //
//   // production.date se month nikalega
//   // ======================================================

//   const getProductionMonth = (
//     item
//   ) => {
//     if (!item?.date) {
//       return "";
//     }

//     const date =
//       new Date(item.date);

//     if (
//       Number.isNaN(
//         date.getTime()
//       )
//     ) {
//       return "";
//     }

//     return date.toLocaleString(
//       "en-US",
//       {
//         month: "long",
//       }
//     );
//   };

//   // ======================================================
//   // GET PRODUCTION QTY
//   //
//   // finalProduct ke fProduct_name.qty se
//   // ======================================================

//  const getProductionQty = (finalProduct) => {
//   const units =
//     finalProduct?.fProduct_name_Units;

//   if (!Array.isArray(units)) {
//     return 0;
//   }

//   const sheetUnit = units.find(
//     (item) =>
//       String(item?.unit || "")
//         .trim()
//         .toLowerCase() === "sheet"
//   );

//   return Number(
//     sheetUnit?.qty || 0
//   );
// };

//   // ======================================================
//   // ACHIEVEMENT QTY
//   //
//   // Same Product + Same Month
//   // ONLY COMPLETED
//   //
//   // Multiple production entries
//   // ki qty ADD hogi
//   // ======================================================

// const achievementQty = useMemo(() => {
//   if (!Array.isArray(productionData)) {
//     return 0;
//   }

//   const total = productionData.reduce(
//     (grandTotal, production) => {

//       // ==========================================
//       // SIRF COMPLETED PRODUCTION
//       // ==========================================

//       const status = String(
//         production?.product_details?.find(
//           (item) => item?.status
//         )?.status || ""
//       )
//         .trim()
//         .toLowerCase();

//       if (status !== "completed") {
//         return grandTotal;
//       }

//       // ==========================================
//       // FINAL PRODUCTS
//       // ==========================================

//       const finalProducts =
//         Array.isArray(
//           production?.product_details?.[0]
//             ?.finalProductDetails
//         )
//           ? production.product_details[0]
//               .finalProductDetails
//           : [];

//       // ==========================================
//       // IS PRODUCTION KE SAARE PRODUCT KI QTY ADD
//       // ==========================================

//       const productionQty =
//         finalProducts.reduce(
//           (productTotal, finalProduct) => {

//            const qty =
//   getProductionQty(finalProduct);

//             return productTotal + qty;
//           },
//           0
//         );

//       // ==========================================
//       // SABHI COMPLETED PRODUCTION KI QTY ADD
//       // ==========================================

//       return grandTotal + productionQty;
//     },
//     0
//   );

//   return total;
// }, [productionData]);


// const productionSummary = useMemo(() => {
//   if (!Array.isArray(productionData)) {
//     return [];
//   }

//   const productMap = new Map();

//   productionData.forEach((production) => {
//     // ==========================================
//     // ONLY COMPLETED
//     // ==========================================

//     const status = String(
//       production?.product_details?.find(
//         (item) => item?.status
//       )?.status || ""
//     )
//       .trim()
//       .toLowerCase();

//     if (status !== "completed") {
//       return;
//     }

//     // ==========================================
//     // FINAL PRODUCTS
//     // ==========================================

//     const finalProducts =
//       Array.isArray(
//         production?.product_details?.[0]
//           ?.finalProductDetails
//       )
//         ? production.product_details[0]
//             .finalProductDetails
//         : [];

//     finalProducts.forEach((finalProduct) => {
//       const fProduct =
//         finalProduct?.fProduct_name;

//       if (!fProduct) return;

//       const productId = String(
//         fProduct?.id ||
//           fProduct?._id ||
//           ""
//       ).trim();

//       const productName =
//         fProduct?.Product_Title ||
//         fProduct?.id ||
//         "-";

//     const qty =
//   getProductionQty(
//     finalProduct
//   );

//       if (!productId) return;

//       if (!productMap.has(productId)) {
//         productMap.set(productId, {
//           productId,
//           productName,
//           achievementQty: 0,
//         });
//       }

//       const existing =
//         productMap.get(productId);

//       existing.achievementQty += qty;
//     });
//   });

//   return Array.from(
//     productMap.values()
//   );
// }, [productionData]);

//   // ======================================================
//   // BALANCE
//   //
//   // TARGET - ACHIEVEMENT
//   // ======================================================

//   const balanceQty =
//     Number(
//       targetQty || 0
//     ) -
//     Number(
//       achievementQty || 0
//     );

//   // ======================================================
//   // FINANCIAL YEAR CHANGE
//   // ======================================================

//   const handleFinancialYearChange =
//     (e) => {
//       const value =
//         e.target.value;

//       setFormData({
//         financialYear:
//           value,

//         month: "",

//         productId: "",

//         productName: "",

//         targetQty: 0,
//       });
//     };

//   // ======================================================
//   // MONTH CHANGE
//   // ======================================================

//   const handleMonthChange = (
//     e
//   ) => {
//     const value =
//       e.target.value;

//     setFormData((prev) => ({
//       ...prev,

//       month: value,

//       productId: "",

//       productName: "",

//       targetQty: 0,
//     }));
//   };

//   // ======================================================
//   // PRODUCT CHANGE
//   // ======================================================

//   const handleProductChange = (
//     e
//   ) => {
//     const productId =
//       e.target.value;

//     const product =
//       products.find(
//         (item) =>
//           String(
//             item?.productId
//           ) ===
//           String(
//             productId
//           )
//       );

//     if (!product) {
//       setFormData((prev) => ({
//         ...prev,

//         productId: "",

//         productName: "",

//         targetQty: 0,
//       }));

//       return;
//     }

//     const productName =
//       getTargetProductName(
//         product
//       );

//     console.log(
//       "Selected Target Product:",
//       product
//     );

//     console.log(
//       "Selected Product ID:",
//       productId
//     );

//     console.log(
//       "Selected Product Name:",
//       productName
//     );

//     setFormData((prev) => ({
//       ...prev,

//       productId:
//         product?.productId ||
//         "",

//       productName:
//         productName,

//       targetQty:
//         Number(
//           product?.targetQty ||
//             0
//         ),
//     }));
//   };

//   // ======================================================
//   // RENDER
//   // ======================================================

//   return (
//     <div className="container-fluid">

//       {/* ==================================================
//           HEADER
//       ================================================== */}

//       <Row className="align-items-center mb-3">

//         <Col md="8">

//           <h4
//             style={{
//               margin: 0,
//               fontWeight: "600",
//             }}
//           >
//             Achievement
//           </h4>

//         </Col>

//         <Col
//           md="4"
//           className="text-end"
//         >

//           <button
//             type="button"
//             className="btn btn-secondary"
//             onClick={() =>
//               navigate(
//                 "/sales-and-purchases?view=targets"
//               )
//             }
//           >
//             Back
//           </button>

//         </Col>

//       </Row>

//       {/* ==================================================
//           FILTER CARD
//       ================================================== */}

//       <Card>

//         <CardBody>

//           <Row>

//             {/* ==========================================
//                 FINANCIAL YEAR
//             ========================================== */}

//             <Col
//               md="4"
//               sm="12"
//               className="mb-3"
//             >

//               <Label
//                 className="fw-semibold"
//               >
//                 Financial Year
//               </Label>

//               <Input
//                 type="select"
//                 value={
//                   formData.financialYear
//                 }
//                 onChange={
//                   handleFinancialYearChange
//                 }
//               >

//                 {getFinancialYears().map(
//                   (year) => (
//                     <option
//                       key={year}
//                       value={year}
//                     >
//                       {year}
//                     </option>
//                   )
//                 )}

//               </Input>

//             </Col>

//             {/* ==========================================
//                 MONTH
//             ========================================== */}

//             <Col
//               md="4"
//               sm="12"
//               className="mb-3"
//             >

//               <Label
//                 className="fw-semibold"
//               >
//                 Month
//               </Label>

//               <Input
//                 type="select"
//                 value={
//                   formData.month
//                 }
//                 onChange={
//                   handleMonthChange
//                 }
//               >

//                 <option value="">
//                   Select Month
//                 </option>

//                 {monthOrder.map(
//                   (month) => (
//                     <option
//                       key={month}
//                       value={month}
//                     >
//                       {month}
//                     </option>
//                   )
//                 )}

//               </Input>

//             </Col>

//             {/* ==========================================
//                 PRODUCT
//             ========================================== */}

//             <Col
//               md="4"
//               sm="12"
//               className="mb-3"
//             >

//               <Label
//                 className="fw-semibold"
//               >
//                 Product
//               </Label>

//               {targetLoading ? (

//                 <div
//                   className="d-flex align-items-center"
//                   style={{
//                     height: "38px",
//                   }}
//                 >

//                   <Spinner
//                     size="sm"
//                     className="me-2"
//                     color="primary"
//                   />

//                   Loading products...

//                 </div>

//               ) : (

//                 <Input
//                   type="select"
//                   value={
//                     formData.productId
//                   }
//                   onChange={
//                     handleProductChange
//                   }
//                   disabled={
//                     !formData.month
//                   }
//                 >

//                   <option value="">
//                     Select Product
//                   </option>

//                   {products.map(
//                     (product) => (

//                       <option
//                         key={
//                           product?.productId
//                         }
//                         value={
//                           product?.productId
//                         }
//                       >
//                         {
//                           getTargetProductName(
//                             product
//                           )
//                         }
//                       </option>

//                     )
//                   )}

//                 </Input>

//               )}

//               {!targetLoading &&
//                 formData.month &&
//                 products.length ===
//                   0 && (

//                   <small className="text-danger">
//                     No target product
//                     found.
//                   </small>

//                 )}

//             </Col>

//           </Row>

//           <hr />

//           {/* ==================================================
//               RESULT
//           ================================================== */}

//           {!formData.productId ? (

//             <div
//               className="text-center text-muted"
//               style={{
//                 padding:
//                   "50px 10px",
//               }}
//             >
//               Select month and
//               product to view
//               Achievement.
//             </div>

//           ) : (

//             <>

//               {/* ==========================================
//                   PRODUCT NAME
//               ========================================== */}

//               <Row className="mb-3">

//                 <Col md="12">

//                   <div
//                     style={{
//                       fontSize:
//                         "16px",
//                       fontWeight:
//                         "600",
//                     }}
//                   >
//                     {
//                       selectedProduct
//                         ? getTargetProductName(
//                             selectedProduct
//                           )
//                         : formData.productName ||
//                           "-"
//                     }
//                   </div>

//                   <div
//                     className="text-muted"
//                     style={{
//                       fontSize:
//                         "13px",
//                       marginTop:
//                         "3px",
//                     }}
//                   >
//                     {formData.month}
//                     {" • "}
//                     {
//                       formData.financialYear
//                     }
//                   </div>

//                 </Col>

//               </Row>

//               {/* ==========================================
//                   QUANTITY CARDS
//               ========================================== */}

//               <Row>

//                 {/* ========================================
//                     TARGET
//                 ======================================== */}

//                 <Col
//                   md="4"
//                   sm="12"
//                   className="mb-3"
//                 >

//                   <div
//                     className="border rounded p-3"
//                     style={{
//                       height:
//                         "100%",
//                       background:
//                         "#f8f9fa",
//                     }}
//                   >

//                     <div
//                       style={{
//                         fontSize:
//                           "13px",
//                         color:
//                           "#6c757d",
//                         marginBottom:
//                           "5px",
//                       }}
//                     >
//                       Target
//                     </div>

//                     <div
//                       style={{
//                         fontSize:
//                           "28px",
//                         fontWeight:
//                           "700",
//                       }}
//                     >
//                       {Number(
//                         targetQty || 0
//                       ).toFixed(2)}
//                     </div>

//                   </div>

//                 </Col>

//                 {/* ========================================
//                     ACHIEVEMENT
//                 ======================================== */}

//                 <Col
//                   md="4"
//                   sm="12"
//                   className="mb-3"
//                 >

//                   <div
//                     className="border rounded p-3"
//                     style={{
//                       height:
//                         "100%",
//                       background:
//                         "#f8f9fa",
//                     }}
//                   >

//                     <div
//                       style={{
//                         fontSize:
//                           "13px",
//                         color:
//                           "#6c757d",
//                         marginBottom:
//                           "5px",
//                       }}
//                     >
//                       Achievement
//                     </div>

//                     {productionLoading ? (

//                       <div>

//                         <Spinner
//                           size="sm"
//                           color="primary"
//                         />

//                       </div>

//                     ) : (

//                       <div
//                         style={{
//                           fontSize:
//                             "28px",
//                           fontWeight:
//                             "700",
//                         }}
//                       >
//                         {Number(
//                           achievementQty ||
//                             0
//                         ).toFixed(2)}
//                       </div>

//                     )}

//                   </div>

//                 </Col>

//                 {/* ========================================
//                     BALANCE
//                 ======================================== */}

//                 <Col
//                   md="4"
//                   sm="12"
//                   className="mb-3"
//                 >

//                   <div
//                     className="border rounded p-3"
//                     style={{
//                       height:
//                         "100%",
//                       background:
//                         "#f8f9fa",
//                     }}
//                   >

//                     <div
//                       style={{
//                         fontSize:
//                           "13px",
//                         color:
//                           "#6c757d",
//                         marginBottom:
//                           "5px",
//                       }}
//                     >
//                       Balance
//                     </div>

//                     {productionLoading ? (

//                       <div>

//                         <Spinner
//                           size="sm"
//                           color="primary"
//                         />

//                       </div>

//                     ) : (

//                       <div
//                         style={{
//                           fontSize:
//                             "28px",
//                           fontWeight:
//                             "700",
//                         }}
//                       >
//                         {Number(
//                           balanceQty
//                         ).toFixed(2)}
//                       </div>

//                     )}

//                   </div>

//                 </Col>

//               </Row>

//               {/* ==========================================
//                   FORMULA
//               ========================================== */}

//               <div
//                 className="mt-3 p-3 border rounded"
//                 style={{
//                   background:
//                     "#fafafa",
//                   fontSize:
//                     "14px",
//                 }}
//               >

//                 <strong>
//                   Balance
//                 </strong>

//                 {" = "}

//                 Target - Achievement

//                 <span className="ms-3">

//                   {Number(
//                     targetQty || 0
//                   ).toFixed(2)}

//                   {" - "}

//                   {Number(
//                     achievementQty ||
//                       0
//                   ).toFixed(2)}

//                   {" = "}

//                   <strong>
//                     {Number(
//                       balanceQty
//                     ).toFixed(2)}
//                   </strong>

//                 </span>

//               </div>

//             </>

//           )}

//         </CardBody>

//       </Card>
// {/* ==================================================
//     PRODUCTION PRODUCT SUMMARY TABLE
// ================================================== */}

// <Card className="mt-4">

//   <CardBody>

//     <div className="d-flex justify-content-between align-items-center mb-3">

//       <div>
//         <h5 className="mb-1">
//           Production Achievement Details
//         </h5>

//         <small className="text-muted">
//           All completed production products
//         </small>
//       </div>

//       <div>
//         <strong>
//           Total Achievement:{" "}
//           {Number(
//             achievementQty || 0
//           ).toFixed(2)}
//         </strong>
//       </div>

//     </div>

//     {productionLoading ? (

//       <div className="text-center p-4">
//         <Spinner
//           color="primary"
//         />
//       </div>

//     ) : productionSummary.length === 0 ? (

//       <div
//         className="text-center text-muted p-4"
//       >
//         No completed production found.
//       </div>

//     ) : (

//       <div className="table-responsive">

//       <table className="table table-bordered table-hover mb-0">

//   <thead>
//     <tr>

//       <th
//         style={{
//           textAlign: "center",
//           verticalAlign: "middle",
//         }}
//       >
//         Product
//       </th>

//       <th
//         style={{
//           textAlign: "center",
//           verticalAlign: "middle",
//         }}
//       >
//         Achievement Qty
//       </th>

//       <th
//         style={{
//           textAlign: "center",
//           verticalAlign: "middle",
//         }}
//       >
//         Target Qty
//       </th>

//       <th
//         style={{
//           textAlign: "center",
//           verticalAlign: "middle",
//         }}
//       >
//         Balance
//       </th>

//     </tr>
//   </thead>

//   <tbody>

//     {productionSummary.map(
//       (item, index) => {

//         const isSelectedTarget =
//           String(
//             item?.productId
//           ).toLowerCase() ===
//           String(
//             formData?.productId
//           ).toLowerCase();

//         const rowTargetQty =
//           isSelectedTarget
//             ? Number(targetQty || 0)
//             : 0;

//         const rowBalance =
//           rowTargetQty -
//           Number(
//             item?.achievementQty || 0
//           );

//         return (
//           <tr
//             key={
//               item?.productId ||
//               index
//             }
//           >

//             {/* PRODUCT */}

//             <td
//               style={{
//                 textAlign: "center",
//                 verticalAlign: "middle",
//               }}
//             >
//               <strong>
//                 {item?.productName || "-"}
//               </strong>
//             </td>

//             {/* ACHIEVEMENT */}

//             <td
//               style={{
//                 textAlign: "center",
//                 verticalAlign: "middle",
//               }}
//             >
//               {Number(
//                 item?.achievementQty || 0
//               ).toFixed(2)}
//             </td>

//             {/* TARGET */}

//             <td
//               style={{
//                 textAlign: "center",
//                 verticalAlign: "middle",
//               }}
//             >
//               {isSelectedTarget
//                 ? Number(
//                     targetQty || 0
//                   ).toFixed(2)
//                 : "0.00"}
//             </td>

//             {/* BALANCE */}

//             <td
//               style={{
//                 textAlign: "center",
//                 verticalAlign: "middle",
//                 fontWeight: "600",
//               }}
//             >
//               {Number(
//                 rowBalance
//               ).toFixed(2)}
//             </td>

//           </tr>
//         );
//       }
//     )}

//   </tbody>

//   {/* TOTAL */}

//   <tfoot>

//     <tr>

//       <th
//         style={{
//           textAlign: "center",
//           verticalAlign: "middle",
//         }}
//       >
//         Total
//       </th>

//       <th
//         style={{
//           textAlign: "center",
//           verticalAlign: "middle",
//         }}
//       >
//         {Number(
//           achievementQty || 0
//         ).toFixed(2)}
//       </th>

//       <th
//         style={{
//           textAlign: "center",
//           verticalAlign: "middle",
//         }}
//       >
//         {Number(
//           targetQty || 0
//         ).toFixed(2)}
//       </th>

//       <th
//         style={{
//           textAlign: "center",
//           verticalAlign: "middle",
//         }}
//       >
//         {Number(
//           balanceQty
//         ).toFixed(2)}
//       </th>

//     </tr>

//   </tfoot>

// </table>

//       </div>

//     )}

//   </CardBody>

// </Card>
//     </div>
//   );
// };

export default CreateAchievement;